import React from 'react';

const Icon = ({ size = '80', fill = 'white', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 80 80" fill="none" {...other}>
            <path
                d="M39.645 5C20.51 5 5 20.527 5 39.68c0 19.15 15.51 34.678 34.645 34.678 19.133 0 34.645-15.528 34.645-34.678C74.29 20.528 58.777 5 39.645 5Zm0 65.891c-17.221 0-31.183-13.975-31.183-31.211 0-17.242 13.963-31.214 31.183-31.214 17.221 0 31.182 13.975 31.182 31.214 0 17.236-13.96 31.211-31.182 31.211ZM55.37 37.222c-5.389-3.672-15.162-9.17-20.732-12.572-2.284-1.445-4.202-.866-4.387 1.68-.135 6.816 0 19.962 0 26.9.113 2.581 2.39 2.923 4.369 1.881l20.705-12.553c-.039-.022 4.24-2.38.046-5.336h-.001Z"
                fill={fill}
            />
        </svg>
    );
};
export default React.memo(Icon);
